import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import Loader from '../../components/Loader/Loader';

export function hasAllPermissions(userPerms, required = []) {
  if (!required.length) return true;
  const set = new Set((userPerms || []).map((p) => String(p).toLowerCase()));
  return required.every((p) => set.has(String(p).toLowerCase()));
}

export function RequirePermission({ permissions, fallback = null, children }) {
  const { user, permissionsLoaded } = useAuth();
  
  if (!permissionsLoaded) {
    return <Loader />;
  }
  
  const ok = hasAllPermissions(user?.permissions, permissions || []);
  return <>{ok ? children : fallback}</>;
}